import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedText } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { Options } from 'models';

import { UitkBadge, UitkBadgeTheme } from 'uitk-react-badge';
import { UitkIcon } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'components/common/disclaimer-dialog';
import { LeadAndSubPrice } from 'components/common/pricing/lead-and-sub-price';

const LinkTracked = ClickTracker(Link);

interface PriceBlockProps {
  hotelId?: number;
  l10n?: any;
  routeStore?: RouteStore;
  sheet: {
    badgeText?: string;
    badgeTheme?: UitkBadgeTheme;
    leadPrice?: string;
    priceMessages?: string[];
    strikeoutDisclaimer?: string;
    strikeoutPrice?: string;
    options?: Options[];
  };
}

export const PriceBlock: React.FunctionComponent<PriceBlockProps> = ({ hotelId, l10n, routeStore, sheet }) => {
  const { badgeText, badgeTheme, leadPrice: lead, priceMessages, strikeoutPrice: strikeout, strikeoutDisclaimer, options } = sheet;

  if (!lead) {
    return (
      <div className="uitk-cell uitk-type-400 map-viewer__info-sheet-price map-viewer__info-sheet-price--soldout">
        <LocalizedText message="maps.sheets.hotel.soldOut.text" />
      </div>
    );
  }

  const dialogId = hotelId ? `priceDisclaimerDialogMap-${hotelId}` : 'priceDisclaimerDialogMap';
  const dialogQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialogNested: dialogId });
  const routeStoreGoBack = () => {
    routeStore.goBack();
  };
  const dialogType = 'pwaDialogNested';
  const wrapPrice = false;
  const priceFontWeight = '600';
  const viewed = false;
  const query = { pathname: routeStore.pathname, search: dialogQuery };

  return (
    <div className="uitk-cell all-cell-1-1 uitk-type-right all-t-padding-two all-r-padding-three">
      {badgeText && badgeTheme && <UitkBadge text={badgeText} theme={UitkBadgeTheme[badgeTheme]} />}
      <div className="uitk-grid all-grid-align-end all-t-padding-half all-cell-1-2 map-viewer__info-sheet-price">
        {options &&
          options.length > 0 && (
            <div className={`uitk-grid all-grid-align-middle all-grid-align-end`}>
              {options.map(option => (
                <LeadAndSubPrice
                  {...{
                    option,
                    strikeoutDisclaimer,
                    query,
                    dialogId,
                    dialogType,
                    routeStoreGoBack,
                    wrapPrice,
                    priceFontWeight,
                    viewed
                  }}
                />
              ))}
            </div>
          )}
        {(!options || options.length === 0) &&
          strikeout && (
            <React.Fragment>
              {strikeoutDisclaimer ? (
                <React.Fragment>
                  <UitkMoreInfoTrigger
                    className="uitk-cell all-cell-fill all-cell-align-end uitk-type-300 uitk-type-medium
                  all-x-padding-one all-t-padding-half map-viewer__info-sheet-price--strikethrough"
                  >
                    <LinkTracked
                      linkName="Price Disclaimer Dialog"
                      rfrr=".Price.DisclaimerDialog.Map"
                      to={{ pathname: routeStore.pathname, search: dialogQuery }}
                    >
                      <UitkIcon name="info_outline" className="pwa-theme--grey-700 all-r-padding-half" />
                      <del>
                        <span className="is-visually-hidden map-viewer__info-sheet-price--strikethrough--a11y">
                          {l10n.formatText('hotels.infosite.rateInfoDialog.strikeOut', strikeout)}
                        </span>
                        <span className="map-viewer__info-sheet-price--strikethrough--text pwa-theme--grey-700" aria-hidden="true">
                          {strikeout}
                        </span>
                      </del>
                    </LinkTracked>
                  </UitkMoreInfoTrigger>
                  <DisclaimerDialog
                    dialogId={dialogId}
                    dialogType="pwaDialogNested"
                    disclaimerText={strikeoutDisclaimer}
                    handleClose={routeStoreGoBack}
                    innerHTML={true}
                    layerId="price-disclaimer-dialog-map"
                    disclaimerTextId="price-disclaimer-text"
                  />
                </React.Fragment>
              ) : (
                <del
                  className="uitk-cell all-cell-fill uitk-type-right uitk-type-300 uitk-type-medium all-x-padding-one
                all-t-padding-half map-viewer__info-sheet-price--strikethrough"
                >
                  <span className="is-visually-hidden map-viewer__info-sheet-price--strikethrough--a11y">
                    {l10n.formatText('hotels.infosite.rateInfoDialog.strikeOut', strikeout)}
                  </span>
                  <span className="map-viewer__info-sheet-price--strikethrough--text pwa-theme--grey-700" aria-hidden="true">
                    {strikeout}
                  </span>
                </del>
              )}
              {lead && <div className="uitk-cell all-cell-shrink all-cell-1-2 uitk-type-bold uitk-type-600">{lead}</div>}
            </React.Fragment>
          )}
        {(!options || options.length === 0) &&
          !strikeout && (
            <React.Fragment>
              {lead && <div className="uitk-cell all-cell-shrink all-cell-1-2 uitk-type-bold uitk-type-600">{lead}</div>}
            </React.Fragment>
          )}
        {priceMessages && (
          <div className="uitk-cell all-cell-1-1" data-stid="price-messages">
            {priceMessages.map(message => (
              <div className="pwa-theme--grey-700 uitk-type-100" key={message}>
                {message}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
